import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LeftOutlined } from '@ant-design/icons'
import SearchInput from '../../components/SearchInput/SearchInput'

// чтобы подхватить стили карточек (.ps-card) 1в1 как у тебя
import '../../components/PlaylistSection.scss'
import './Bussiness.scss'

type DemoPlaylist = {
  _id: string
  title: string
  subtitle: string
  image: string
}

const BG =
  'https://liquidesign.co.uk/wp-content/uploads/2023/06/Brew-92-Jeddah-850_7048.jpg'

// demo-обложки (можешь заменить на свои локальные)
const covers = [
  'https://images.unsplash.com/photo-1526498460520-4c246339dccb?auto=format&fit=crop&w=700&q=80',
  'https://images.unsplash.com/photo-1526481280695-3c687fd5432c?auto=format&fit=crop&w=700&q=80',
  'https://images.unsplash.com/photo-1526483360412-f4dbaf036963?auto=format&fit=crop&w=700&q=80',
  'https://images.unsplash.com/photo-1526481280690-9066b1a16c0c?auto=format&fit=crop&w=700&q=80',
]

export default function Bussiness() {
  const navigate = useNavigate()
  const CARD_IMG = '/random.jpg'

  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 900px)')
    const onChange = () => setIsMobile(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const [search, setSearch] = useState('')

  const demoPlaylists: DemoPlaylist[] = useMemo(() => {
    return Array.from({ length: 24 }).map((_, i) => ({
      _id: `pl_${i}`,
      title: i % 2 === 0 ? 'R&B Playlist' : 'Daily Mix 2',
      subtitle: i % 2 === 0 ? 'Chill your mind' : 'Made for you',
      image: CARD_IMG, // ✅ одно фото для всех
    }))
  }, [])

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    if (!q) return demoPlaylists
    return demoPlaylists.filter(
      (p) => p.title.toLowerCase().includes(q) || p.subtitle.toLowerCase().includes(q),
    )
  }, [search, demoPlaylists])

  return (
    <div className="biz" style={{ ['--biz-hero' as any]: `url(${BG})` }}>
      {/* HERO */}
      <div className="biz-hero">
        <div className="biz-heroBg" aria-hidden="true" />
        <div className="biz-heroShade" aria-hidden="true" />

        {/* search как на скрине */}
        <div className="biz-search">
          <SearchInput
            value={search}
            onChange={(v: any) =>
              setSearch(typeof v === 'string' ? v : (v?.target?.value ?? ''))
            }
          />
        </div>

        <div className="biz-heroCenter">
          <div className="biz-avatar" aria-hidden="true">
            <img src={BG} alt="" />
          </div>

          <div className="biz-heroText">
            <div className="biz-heroTitle">Caffes</div>
            <div className="biz-heroSub">CHILL YOUR MIND</div>
          </div>
        </div>
      </div>

      {/* BODY */}
      <div className="biz-body">
        <div className="biz-head">
          <button
            type="button"
            className="biz-back"
            onClick={() => navigate(-1)}
            aria-label="Back"
          >
            <LeftOutlined />
          </button>

          <h1 className="biz-h1">Playlists</h1>
        </div>

        {/* GRID карточек (те же .ps-card стили, но сетка) */}
        <div className="biz-grid" aria-label="Playlists grid">
          {filtered.map((p) => (
            <button
              key={p._id}
              type="button"
              className="ps-card"
              onClick={() => navigate(`/playlist/${p._id}`)}
              title={p.title}
            >
              <div className="ps-card__imgWrap">
                <img
                  className="ps-card__img"
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                />
              </div>

              <div className="ps-card__text">
                <div className="ps-card__name">{p.title}</div>
                <div className="ps-card__sub">{p.subtitle}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
